import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { heroConfig } from '@/data/site';

export const Hero = () => (
  <section className="hero">
    <Container>
      <div className="hero__inner">
        <div className="hero__lead">
          <span className="hero__eyebrow">{heroConfig.eyebrow}</span>
          <h1>{heroConfig.headline}</h1>
        </div>

        <div className="hero__aside">
          <p className="hero__dek">{heroConfig.dek}</p>
          <div className="hero__actions">
            <Link className="button button--primary" to={heroConfig.primaryCta.to}>
              {heroConfig.primaryCta.label}
            </Link>
            <a className="button button--ghost" href={heroConfig.secondaryCta.href}>
              {heroConfig.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>
    </Container>
  </section>
);
